import { defineStore } from 'pinia'

export const useUserStore = defineStore({
  id: 'user',
  state: () => ({
    needAccessibility: false as boolean,
    navigateWithNVDA: false as boolean,
    firefoxUser: false as boolean
  }),
  getters: {
    accessibleNavigation(state) {
      return state.needAccessibility
    },
    isUsingNVDA(state) {
      return state.navigateWithNVDA
    },
    isUsingFirefox(state) {
      return state.firefoxUser
    }
  },
  actions: {
    setNavigationHasAccessible() {
      this.needAccessibility = true
    },
    setNavigationWithNVDA() {
      this.navigateWithNVDA = true
    },
    setIsUsingFirefox() {
      this.firefoxUser = navigator.userAgent.search('Firefox') !== -1

      /**
       * Since_Windows Narrator doesn't work well in pair with Firefox,
       * We enforce NVDA tool.
       * See ticket https://gitlab.com/trimoz/development/teams/unified-dev/-/issues/1313
       */
      if (this.firefoxUser) {
        this.setNavigationWithNVDA()
      }
    }
  }
})
